import { Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { formatRecruiterWorkspaceLabel } from '@/components/recruiter/formatRecruiterWorkspaceLabel';
import {
  ALL_WORKSPACES_VALUE,
  useRecruiterWorkspace,
} from '@/hooks/useRecruiterWorkspace';

/**
 * Header switcher for multi-membership recruiters (T8.1).
 * Hidden when the user has fewer than two workspaces.
 */
const RecruiterWorkspaceSwitcher = () => {
  const { t } = useTranslation();
  const {
    workspaces,
    selectedWorkspaceId,
    hasMultipleWorkspaces,
    isLoading,
    setWorkspace,
  } = useRecruiterWorkspace();

  if (!hasMultipleWorkspaces) {
    return null;
  }

  const selectValue = selectedWorkspaceId ?? ALL_WORKSPACES_VALUE;

  return (
    <Select
      data-testid="recruiter-workspace-switcher"
      loading={isLoading}
      value={selectValue}
      style={{ minWidth: 280 }}
      popupMatchSelectWidth={false}
      aria-label={t('SWITCH_PROJECT')}
      showSearch={{ optionFilterProp: 'label' }}
      onChange={(value) => {
        setWorkspace(value === ALL_WORKSPACES_VALUE ? null : String(value));
      }}
      options={[
        {
          value: ALL_WORKSPACES_VALUE,
          label: t('ALL_WORKSPACES'),
        },
        ...workspaces.map((workspace) => ({
          value: workspace.id,
          label: formatRecruiterWorkspaceLabel(workspace),
        })),
      ]}
      labelRender={(props) => (
        <Typography.Text>
          {typeof props.label === 'string' ? props.label : t('SWITCH_PROJECT')}
        </Typography.Text>
      )}
    />
  );
};

export default RecruiterWorkspaceSwitcher;
